import { Component, OnInit } from '@angular/core';
import { BaseDetailListSum, UserService } from 'yt-ng-framework';
import { DecimalPipe } from '@angular/common';
import { TrosakDokumentStavkaView } from './trosak-dokument-stavka-view';

@Component({
  selector: 'yt-trosak-dokument-sum',
  templateUrl: './trosak-dokument-sum.component.html'
})
export class TrosakDokumentSumComponent extends BaseDetailListSum<TrosakDokumentStavkaView> {

  constructor(
    protected decimalPipe: DecimalPipe,
    protected userService: UserService
){
    super();
}

private _iznos: number = 0;
iznos: string;

calculate(){
  super.calculate();
  
  this._iznos = 0;

  if(this.Items && this.Items.size > 0){
    this.Items.forEach((item: TrosakDokumentStavkaView) => {
      this._iznos += item.Iznos;      
  })
  }
  this.iznos = this.decimalPipe.transform(this._iznos, this.userService.GetNumberFormat(), this.userService.GetLocaleString());


}

}
